var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasRenewCart
      ? _c(
          "div",
          {
            staticClass:
              "fs-3 px-3 lh-20 card-ping-upsell primary-05-bkg b-1-primary-10 br mb-4"
          },
          [
            _c("span", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Le renouvellement de votre abonnement est prévu le %(date)s, vous ne pouvez plus modifier votre abonnement seul jusqu’à cette date.",
                      {
                        date: _vm.$options.filters.dateFormatter(
                          _vm.renewActiveDate,
                          "NORMAL_DATE",
                          false
                        )
                      }
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "semibold" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Besoin d'aide ?")))
            ]),
            _vm._v(" "),
            _c(
              "el-link",
              {
                staticClass: "semibold",
                attrs: {
                  disabled: _vm.disablePing,
                  underline: false,
                  type: "primary"
                },
                on: { click: _vm.pingToUpsell }
              },
              [
                _vm._v(
                  _vm._s(_vm.$l10n.__("Demander à être recontacté.")) +
                    "\n        "
                )
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("h2", { staticClass: "m-0" }, [
      _vm._v(_vm._s(_vm.$l10n.__("Mon abonnement Sellsy")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: !_vm.loaded,
            expression: "!loaded"
          }
        ],
        staticClass: "mt-3"
      },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeTab,
              callback: function($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t.__("common.labels.subscription"),
                  name: "overview"
                }
              },
              [
                _c("overview", {
                  attrs: {
                    licenseAssignement: _vm.licenseAssignement,
                    isChargebeeProvider: _vm.isChargebeeProvider,
                    chargebeeSubscriptionId: _vm.chargebeeSubscriptionId,
                    chargebeeThirdPartyPayerId: _vm.chargebeeThirdPartyPayerId
                  },
                  on: {
                    "go-to-staffs": function($event) {
                      _vm.activeTab = "staffs"
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t.__(
                    "sellsyaccountmanager.SubscriptionManager.licences_management"
                  ),
                  name: "staffs"
                }
              },
              [
                _c("staffs", {
                  attrs: { licenseAssignement: _vm.licenseAssignement }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.shouldDisplayDocsPane
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t.__(
                        "common.labels.invoices_and_credit_notes"
                      ),
                      name: "documents"
                    }
                  },
                  [
                    _c("documents", {
                      attrs: {
                        documents: _vm.documents,
                        isChargebeeProvider: _vm.isChargebeeProvider
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }